<template>
  <CCard class="my-5 p-5 card-container">
    <CContainer>
      <CRow class="mb-2">
        <h2 class="font-weight-bold mb-2 text-center w-100">
          {{ $t('automation.date.card.title') }}
        </h2>
        <p class="text-gray-700 text-center">
          {{ $t('automation.date.card.description') }}
        </p>
      </CRow>
      <div v-if="loadingAudienceSchema" class="d-flex justify-content-center align-items-center">
        <CSpinner style="width: 4rem; height: 4rem" />
      </div>
      <div v-else>
        <CRow class="d-flex justify-content-around">
          <CCard
            v-for="dateType in dateTypes"
            @click="dateType.action"
            :class="{ '--selected': dateType.id == selectedTypeId, '--disabled': dateType.isOptionDisabled }"
            class="my-3 p-4 border-gray-300 card-option justify-content-between"
          >
            <img :src="`img/${dateType.imgName}`" class="card-image" />
            <span class="font-weight-bold font-xl text-center">{{ dateType.typeName }}</span>
          </CCard>
        </CRow>
      </div>
    </CContainer>
    <AutomationNewModal ref="modal" :dateFieldsList="dateFieldsList" />
  </CCard>
</template>

<script>
import { getSchema, FIELD_VALUES } from '@/utils/audienceSchema'
import AutomationNewModal from '../components/AutomationNewModal.vue'

const dateTypesIds = {
  birthday: 0,
  customDate: 1,
}

const dataTypesEnum = {
  DATE: 'DATE',
}

export default {
  name: 'AutomationDate',
  components: {
    AutomationNewModal,
  },
  data() {
    return {
      openModal: false,
      selectedTypeId: null,
      loadingAudienceSchema: false,
      audienceSchema: null,
      dateFieldsList: [],
    }
  },
  computed: {
    dateTypes() {
      return [
        {
          id: dateTypesIds.birthday,
          typeName: this.$t('automation.date.type.0'),
          action: this.birthdayAction,
          imgName: 'birthday.svg',
          isOptionDisabled: !this.hasAnyBirthDateField,
        },
        {
          id: dateTypesIds.customDate,
          typeName: this.$t('automation.date.type.1'),
          action: this.customDateAction,
          imgName: 'custom-date.svg',
          isOptionDisabled: false,
        },
      ]
    },
    hasAnyBirthDateField() {
      if (!this.audienceSchema) return

      return this.audienceSchema.some((schema) => {
        return schema.value == FIELD_VALUES.BIRTH_DATE
      })
    },
  },
  mounted() {
    this.getAudienceSchema()
  },
  methods: {
    birthdayAction() {
      this.selectedTypeId = dateTypesIds.birthday

      this.$refs.modal.openModal(true)
    },
    customDateAction() {
      this.selectedTypeId = dateTypesIds.customDate
      this.$refs.modal.openModal(false)
    },

    filterDateFields(values) {
      return values
        .filter((el) => el.dataType.value == dataTypesEnum.DATE)
        .map((el) => {
          // Adiciona as propriedades necessárias para a listagem
          return {
            key: el.key,
            value: el.value,
          }
        })
    },
    async getAudienceSchema() {
      try {
        this.loadingAudienceSchema = true
        const organizationId = this.$route.params.organizationId
        this.audienceSchema = await getSchema(organizationId)
        // adiciona a listagem de tipos
        this.dateFieldsList = this.filterDateFields(this.audienceSchema)

        if (this.audienceSchema && this.hasAnyBirthDateField) {
          return
        }
        this.showDateFieldAlert = true
      } finally {
        this.loadingAudienceSchema = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card-container {
  max-width: 970px;
  margin: auto;
}

.card-option {
  width: 316px;
  height: 290px;
  cursor: pointer;
  box-shadow: none !important;
  > .card-image {
    max-width: 172px;
    margin: auto;
  }
  &.--selected {
    border: 2px solid black !important;
  }
  &.--disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.7;
    background-color: var(--purple-50) !important;
  }
}
</style>
